/**
 * @Author: WeiZisen
 * @Date: 2021-04-08 15:11:08
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-04-08 15:14:18
 * @Description: 验证规则-参数定义
 * @FilePath: \Vue_RebarProcess\src\validate\basic-data\basic-define.js
 */

export let rules = {
  name: [{ required: true, message: '请填写参数名称', trigger: 'blur' }],
  code: [{ required: true, message: '请填写参数编码', trigger: 'blur' }],
}
